import { Col, Row, } from "antd";
import CategoryList from "./Component/CategoryList";
import StaticPageBanner from "apps/Common/StaticPageBanner";
import { Helmet } from "react-helmet-async";

const SiteMapIndex = () => {

  return (
    <>

      <Col xs={24}>
        <Row gutter={[20, 20]}>
          <Col xs={24}>
            <StaticPageBanner
              title=" Site Haritası"
              description=" İstediğiniz Kategorilere Hızlıca Ulaşınız"
            />
            <Helmet>
              <title className="capitalize">{"Site Haritası"}</title>
            </Helmet>

          </Col>
          <Col xs={24} >
            <Row gutter={[20, 20]} className="!px-2 lg:!px-6 xxl:!px-16" >
              <Col xs={24} md={12} >
                <CategoryList categoryId={"vasita"} />
              </Col>
              <Col xs={24} md={12} >
                <CategoryList categoryId={"gayrimenkul"} />
              </Col>

            </Row>
          </Col>
        </Row>
      </Col>

    </>
  );
};

export default SiteMapIndex;
